import { gql } from "generated-graphql";

// The canonical vendor-name list, the id-bearing vendor table, and the
// "create a canonical vendor" mutation all already exist in the sibling
// Waste Vendors tab, so re-export rather than re-declare — graphql-codegen
// fails on duplicate operation names.
export {
  CREATE_WASTE_MANIFEST_VENDOR,
  WASTE_MANIFEST_VENDOR_NAMES_QUERY,
  WASTE_MANIFEST_VENDORS_TABLE_QUERY,
} from "../WasteVendors/api";

export const VENDOR_DATA_COMPLETENESS_QUERY = gql(/* GraphQL */ `
  query WasteVendorDataCompleteness(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    wasteVendorDataCompleteness(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      count
      items {
        id
        tenantId
        tenantName
        vendorId
        vendorName
        observedNames
        isExpected
        needsMapping
        isActive
        status
        periodsBehind
        cadence
        dueByDayOfMonth
        intake
        notes
        firstReceivedAt
        lastReceivedAt
        coveredThrough
        importCount
        manifestCount
        lastPipelineRunAt
        lastPipelineIngestedAt
        awaitingIngestCount
        pipelineApproved
        pipelineApproval
      }
    }
  }
`);

export const UPSERT_TENANT_WASTE_VENDOR = gql(/* GraphQL */ `
  mutation UpsertTenantWasteVendor($input: UpsertTenantWasteVendorInput!) {
    upsertTenantWasteVendor(input: $input) {
      id
      cadence
      dueByDayOfMonth
      intake
      isActive
      notes
      pipelineApproved
    }
  }
`);

export const DELETE_TENANT_WASTE_VENDOR = gql(/* GraphQL */ `
  mutation DeleteTenantWasteVendor($id: ID!) {
    deleteTenantWasteVendor(id: $id)
  }
`);

// Named distinctly from the sibling dialog's own tenant search (operation
// names must be unique for graphql-codegen) even though the query shape is
// copied from it.
export const VENDOR_DATA_TENANTS_QUERY = gql(/* GraphQL */ `
  query VendorDataTenants($search: String, $pageSize: Int, $sort: [SortModel!]) {
    tenants(search: $search, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
      }
      count
    }
  }
`);

// Powers the "Scan observed vendor data" drawer. No arguments — it always
// scans every tenant's historical manifests, so it is gated behind the
// drawer's `open` prop (a query `skip`) rather than run on page load; see
// ObservedDataDrawer.tsx.
export const WASTE_VENDOR_OBSERVED_DATA_QUERY = gql(/* GraphQL */ `
  query WasteVendorObservedData {
    wasteVendorObservedData {
      tenantId
      tenantName
      observedNames
      vendorId
      vendorName
      manifestCount
      firstReceivedAt
      lastReceivedAt
      coveredThrough
      hasExpectation
    }
  }
`);

export const CREATE_WASTE_MANIFEST_VENDOR_ALIAS = gql(/* GraphQL */ `
  mutation CreateWasteManifestVendorAlias($input: CreateWasteManifestVendorAliasInput!) {
    createWasteManifestVendorAlias(input: $input) {
      id
      alias
    }
  }
`);
